import { render } from "./FooterView2.vue?vue&type=template&id=8dbb7f0c&scoped=true"
import script from "./FooterView2.vue?vue&type=script&lang=js"
export * from "./FooterView2.vue?vue&type=script&lang=js"

import "./FooterView2.vue?vue&type=style&index=0&id=8dbb7f0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dbb7f0c"]])

export default __exports__